import * as types from './mutation-types'

const mutations = {
    [types.LOGIN](state) {
      state.pending = true
    },
    [types.LOGIN_SUCCESS](state, data) {
      state.permissions = data.permissions
  
      state.isLoggedIn = true
      state.pending = false
      state.userName = data.userName
      state.userID = data.userID
      state.disabled = false
    },
    [types.LOGOUT](state) {
      state.isLoggedIn = false
    },
    [types.LOGIN_DISABLED](state, data) {
      state.disabled = true
    },
  }
export default mutations;


// WEBPACK FOOTER //
// ./src/store/modules/login/mutations.js